import { LayoutActionSelection } from './layout/LayoutActionSelection'

export const ActionSelectionScreen = () => {
    return (
        <LayoutActionSelection />
    )
}
